<template>
  <div class="form-group-simple"
  :class="{
    'form-group-simple--completed': completed,
    'form-group-simple--error': errors.has('postalcode')}">

    <label for="Postcode">{{ label }}</label>

    <input
      ref="input"
      type="text"
      v-model="postalcode"
      :name="name"
      placeholder="1234 AA"
      @blur="blur">

    <div class="form-group-simple__details">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-show="errors.has('postalcode')">{{ errors.first('postalcode') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'

export default {
  name: 'v-input-postalcode-simple',
  props: {
    name: {
      default: 'Postcode',
      type: String
    },
    label: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      postalcode: '',
      errors: '',
      completed: false
    }
  },
  created () {
    this.validator = new Validator()
    this.validator.attach('postalcode', {
      required: 'required',
      regex: [/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i]
    }, { alias: 'Postcode' })
    this.$set(this, 'errors', this.validator.errors)
  },
  methods: {
    validate () {
      this.validator.validate('postalcode', this.postalcode)
    },
    blur () {
      this.validate()
    },
    setFocus () {
      this.$refs.input.focus()
    }
  },
  watch: {
    postalcode (value) {
      if (value.length > 4 && value.charAt(4) !== ' ') {
        this.postalcode = this.postalcode.substr(0, 4) + ' ' + this.postalcode.substr(4)
      }

      // End of input, validate it to see if it is complete
      if (value.length > 6) {
        // Validate postalcode
        this.validator.validate('postalcode', this.postalcode)
        // If input has no errors
        if (!this.errors.has('postalcode')) {
          this.completed = true
          this.$emit('nextInput')
        } else {
          this.completed = false
        }
        this.$emit('updateValidation', this.completed)
      }
    }
  }
}
</script>
